// tslint:disable:max-line-length

import React from 'react';

export const LayoutGrid = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M16,9v7H9V9H16z M7,9v7H0V9H7z M16,0v7H9V0H16z M7,0v7H0V0H7z" />
    </svg>
  );
};
